import { Box } from '@mui/material';
import { ReactNode } from 'react';

export default function RichTextWrapper({
  children,
}: {
  children: ReactNode;
}) {
  return <Box component="div">{children}</Box>;
}
